import React from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { CustomerFormViewProps } from "models/propTypes/customerPropTypes";
import { CustomerFormTypes } from "models/formTypes";
//#endregion
//#region  components
import { useWintForm, useWintWizard, WintForm, WizardFormSectionContainer } from "components/common/wintForms";
import CustomerSelectionWizardStep from "./sections/create/wizardStepSelection";
import GeneralInfoWizardStep from "./sections/create/wizardStepGeneralInfo";
import InvoiceSettingsWizardStep from "./sections/create/wizardStepInvoiceSettings";
import CreateOnChangeHandlers from "./sections/create/useChangeHandlers";
import CreateCustomerFooter from "./createFooter";
import useInvoiceSettings from "./sections/create/useInvoiceSettings";
//#endregion

const CustomerCreateForm: React.FC<CustomerFormViewProps> = (props) => {
  const {
    selectedCustomerChangeHandler,
    organizationNumberChangeHandler,
    isCreate,
    canToggleActiveStatus,
    customer,
    onFormSubmitSuccess,
  } = props;

  const formRef = React.useRef<FormHandles>(null);

  const onCustomerSubmit = () => {
    return (formRef.current && formRef.current.submit()) || new Promise<void>((resolve) => resolve());
  };

  const { wintFormProps, formState, connect, values, submitted, setValues } = useWintForm<CustomerFormTypes.Create>({
    formRef: formRef,
    defaultValues: props.defaultValues,
    validationSchema: props.getValidationSchema(),
    handleSubmit: props.handleSubmit,
    onFormValidationChange: props.onFormValidationChange,
    enableReinitialize: true,
  });

  const wizard = useWintWizard(formState);

  const onSubmitSuccess = (customerId?: number) => {
    onFormSubmitSuccess && onFormSubmitSuccess(customerId, values.generalInfo?.name, values.generalInfo?.orgNumber);
  };

  const { invoiceSettings } = useInvoiceSettings();

  return (
    <WintForm {...wintFormProps}>
      <CreateOnChangeHandlers
        values={values}
        connect={connect}
        selectedCustomerChangeHandler={selectedCustomerChangeHandler}
        organizationNumberChangeHandler={organizationNumberChangeHandler}
        isFormDirty={formState.dirty}
      />
      <WizardFormSectionContainer wizardProps={wizard}>
        <CustomerSelectionWizardStep
          connect={connect}
          setValues={setValues}
          submitted={submitted}
          wizardProps={wizard}
          customerName={props.customerName}
        />
        <GeneralInfoWizardStep
          connect={connect}
          submitted={submitted}
          wizardProps={wizard}
          isCreate={isCreate}
          customerId={customer?.id}
          canToggleActiveStatus={canToggleActiveStatus}
        />
        <InvoiceSettingsWizardStep
          connect={connect}
          submitted={submitted}
          wizardProps={wizard}
          invoiceSettings={invoiceSettings}
        />
      </WizardFormSectionContainer>
      <CreateCustomerFooter
        form={formState}
        submitForm={onCustomerSubmit}
        onSubmitSuccess={onSubmitSuccess}
        wizard={wizard}
      />
    </WintForm>
  );
};

export default CustomerCreateForm;
